import firebase from 'firebase/app'
import 'firebase/firestore'

const config = {
  apiKey: "AIzaSyCEjomRoEtI6rzRczx89xLz5u-eBayQjIE",
  authDomain: "megalovue.firebaseapp.com",
  databaseURL: "https://megalovue.firebaseio.com",
  projectId: "megalovue",
  storageBucket: "megalovue.appspot.com",
  messagingSenderId: "565714404591",
  appId: "1:565714404591:web:40aed7c109f7688890071a",
  measurementId: "G-S1QYTKMRDD"
}


export const db = firebase.initializeApp(config).firestore()

